export enum ConditionType {
	ALL,
	ANY
}

export class ConditionTypeBuilder {
	public static build(type: string): ConditionType {
		switch (type) {
			case 'any':
				return ConditionType.ANY;
			case 'all':
			default:
				return ConditionType.ALL;
		}
	}
}
